import React from 'react'
import { Button, Chip, Icon, icons, theme } from 'cdh-data-portal-theme'
import type { FilterFacet, FilterFacetKey } from '../RegistryFilters.static'
import type { SelectedFilterValues } from '../RegistryFiltersDialog/RegistryFiltersDialog.logic'
import { localText } from './RegistryActiveFilters.static'
import { useStyles } from './RegistryActiveFilters.style'

export interface RegistryActiveFiltersProps {
  readonly facets: readonly FilterFacet[]
  readonly selectedValues: SelectedFilterValues
  readonly onFacetCleared: (key: FilterFacetKey) => void
  readonly onFacetChipClicked: () => void
  readonly onClearAll: () => void
}

export const RegistryActiveFilters: React.FC<RegistryActiveFiltersProps> = ({
  facets,
  selectedValues,
  onFacetCleared,
  onFacetChipClicked,
  onClearAll,
}) => {
  const { classes } = useStyles()
  const activeFacets = facets.filter((facet) => selectedValues[facet.key])

  if (activeFacets.length === 0) {
    return null
  }

  return (
    <div className={classes.root}>
      <div className={classes.chipsContainer}>
        {activeFacets.map((facet) => {
          const selectedOption = facet.options.find((option) => option.id === selectedValues[facet.key])

          return (
            <Chip
              key={facet.key}
              icon={<Icon color={theme.textColors.primary} iconPath={facet.icon} size={24} />}
              label={`${facet.title}: ${selectedOption?.name ?? selectedValues[facet.key]}`}
              onClick={onFacetChipClicked}
              onDelete={() => onFacetCleared(facet.key)}
            />
          )
        })}
      </div>
      <Button icon={icons.close} onClick={onClearAll} title={localText.clearAll} variant="text" />
    </div>
  )
}
